/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateConcept = /* GraphQL */ `subscription OnCreateConcept($filter: ModelSubscriptionConceptFilterInput) {
  onCreateConcept(filter: $filter) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateConceptSubscriptionVariables,
  APITypes.OnCreateConceptSubscription
>;
export const onUpdateConcept = /* GraphQL */ `subscription OnUpdateConcept($filter: ModelSubscriptionConceptFilterInput) {
  onUpdateConcept(filter: $filter) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateConceptSubscriptionVariables,
  APITypes.OnUpdateConceptSubscription
>;
export const onDeleteConcept = /* GraphQL */ `subscription OnDeleteConcept($filter: ModelSubscriptionConceptFilterInput) {
  onDeleteConcept(filter: $filter) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteConceptSubscriptionVariables,
  APITypes.OnDeleteConceptSubscription
>;
export const onCreateUserConcepts = /* GraphQL */ `subscription OnCreateUserConcepts(
  $filter: ModelSubscriptionUserConceptsFilterInput
) {
  onCreateUserConcepts(filter: $filter) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserConceptsSubscriptionVariables,
  APITypes.OnCreateUserConceptsSubscription
>;
export const onUpdateUserConcepts = /* GraphQL */ `subscription OnUpdateUserConcepts(
  $filter: ModelSubscriptionUserConceptsFilterInput
) {
  onUpdateUserConcepts(filter: $filter) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserConceptsSubscriptionVariables,
  APITypes.OnUpdateUserConceptsSubscription
>;
export const onDeleteUserConcepts = /* GraphQL */ `subscription OnDeleteUserConcepts(
  $filter: ModelSubscriptionUserConceptsFilterInput
) {
  onDeleteUserConcepts(filter: $filter) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserConceptsSubscriptionVariables,
  APITypes.OnDeleteUserConceptsSubscription
>;
export const onCreateAdminRole = /* GraphQL */ `subscription OnCreateAdminRole($filter: ModelSubscriptionAdminRoleFilterInput) {
  onCreateAdminRole(filter: $filter) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAdminRoleSubscriptionVariables,
  APITypes.OnCreateAdminRoleSubscription
>;
export const onUpdateAdminRole = /* GraphQL */ `subscription OnUpdateAdminRole($filter: ModelSubscriptionAdminRoleFilterInput) {
  onUpdateAdminRole(filter: $filter) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAdminRoleSubscriptionVariables,
  APITypes.OnUpdateAdminRoleSubscription
>;
export const onDeleteAdminRole = /* GraphQL */ `subscription OnDeleteAdminRole($filter: ModelSubscriptionAdminRoleFilterInput) {
  onDeleteAdminRole(filter: $filter) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAdminRoleSubscriptionVariables,
  APITypes.OnDeleteAdminRoleSubscription
>;
export const onCreateAdminGroup = /* GraphQL */ `subscription OnCreateAdminGroup(
  $filter: ModelSubscriptionAdminGroupFilterInput
) {
  onCreateAdminGroup(filter: $filter) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAdminGroupSubscriptionVariables,
  APITypes.OnCreateAdminGroupSubscription
>;
export const onUpdateAdminGroup = /* GraphQL */ `subscription OnUpdateAdminGroup(
  $filter: ModelSubscriptionAdminGroupFilterInput
) {
  onUpdateAdminGroup(filter: $filter) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAdminGroupSubscriptionVariables,
  APITypes.OnUpdateAdminGroupSubscription
>;
export const onDeleteAdminGroup = /* GraphQL */ `subscription OnDeleteAdminGroup(
  $filter: ModelSubscriptionAdminGroupFilterInput
) {
  onDeleteAdminGroup(filter: $filter) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAdminGroupSubscriptionVariables,
  APITypes.OnDeleteAdminGroupSubscription
>;
export const onCreateAccount = /* GraphQL */ `subscription OnCreateAccount($filter: ModelSubscriptionAccountFilterInput) {
  onCreateAccount(filter: $filter) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAccountSubscriptionVariables,
  APITypes.OnCreateAccountSubscription
>;
export const onUpdateAccount = /* GraphQL */ `subscription OnUpdateAccount($filter: ModelSubscriptionAccountFilterInput) {
  onUpdateAccount(filter: $filter) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAccountSubscriptionVariables,
  APITypes.OnUpdateAccountSubscription
>;
export const onDeleteAccount = /* GraphQL */ `subscription OnDeleteAccount($filter: ModelSubscriptionAccountFilterInput) {
  onDeleteAccount(filter: $filter) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAccountSubscriptionVariables,
  APITypes.OnDeleteAccountSubscription
>;
export const onCreateReservation = /* GraphQL */ `subscription OnCreateReservation(
  $filter: ModelSubscriptionReservationFilterInput
) {
  onCreateReservation(filter: $filter) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateReservationSubscriptionVariables,
  APITypes.OnCreateReservationSubscription
>;
export const onUpdateReservation = /* GraphQL */ `subscription OnUpdateReservation(
  $filter: ModelSubscriptionReservationFilterInput
) {
  onUpdateReservation(filter: $filter) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateReservationSubscriptionVariables,
  APITypes.OnUpdateReservationSubscription
>;
export const onDeleteReservation = /* GraphQL */ `subscription OnDeleteReservation(
  $filter: ModelSubscriptionReservationFilterInput
) {
  onDeleteReservation(filter: $filter) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteReservationSubscriptionVariables,
  APITypes.OnDeleteReservationSubscription
>;
export const onCreateRating = /* GraphQL */ `subscription OnCreateRating($filter: ModelSubscriptionRatingFilterInput) {
  onCreateRating(filter: $filter) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRatingSubscriptionVariables,
  APITypes.OnCreateRatingSubscription
>;
export const onUpdateRating = /* GraphQL */ `subscription OnUpdateRating($filter: ModelSubscriptionRatingFilterInput) {
  onUpdateRating(filter: $filter) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRatingSubscriptionVariables,
  APITypes.OnUpdateRatingSubscription
>;
export const onDeleteRating = /* GraphQL */ `subscription OnDeleteRating($filter: ModelSubscriptionRatingFilterInput) {
  onDeleteRating(filter: $filter) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRatingSubscriptionVariables,
  APITypes.OnDeleteRatingSubscription
>;
export const onCreateConversation = /* GraphQL */ `subscription OnCreateConversation(
  $filter: ModelSubscriptionConversationFilterInput
) {
  onCreateConversation(filter: $filter) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateConversationSubscriptionVariables,
  APITypes.OnCreateConversationSubscription
>;
export const onUpdateConversation = /* GraphQL */ `subscription OnUpdateConversation(
  $filter: ModelSubscriptionConversationFilterInput
) {
  onUpdateConversation(filter: $filter) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateConversationSubscriptionVariables,
  APITypes.OnUpdateConversationSubscription
>;
export const onDeleteConversation = /* GraphQL */ `subscription OnDeleteConversation(
  $filter: ModelSubscriptionConversationFilterInput
) {
  onDeleteConversation(filter: $filter) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteConversationSubscriptionVariables,
  APITypes.OnDeleteConversationSubscription
>;
export const onCreateMessage = /* GraphQL */ `subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput) {
  onCreateMessage(filter: $filter) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMessageSubscriptionVariables,
  APITypes.OnCreateMessageSubscription
>;
export const onUpdateMessage = /* GraphQL */ `subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput) {
  onUpdateMessage(filter: $filter) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMessageSubscriptionVariables,
  APITypes.OnUpdateMessageSubscription
>;
export const onDeleteMessage = /* GraphQL */ `subscription OnDeleteMessage($filter: ModelSubscriptionMessageFilterInput) {
  onDeleteMessage(filter: $filter) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMessageSubscriptionVariables,
  APITypes.OnDeleteMessageSubscription
>;
export const onCreateMessaging = /* GraphQL */ `subscription OnCreateMessaging($filter: ModelSubscriptionMessagingFilterInput) {
  onCreateMessaging(filter: $filter) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMessagingSubscriptionVariables,
  APITypes.OnCreateMessagingSubscription
>;
export const onUpdateMessaging = /* GraphQL */ `subscription OnUpdateMessaging($filter: ModelSubscriptionMessagingFilterInput) {
  onUpdateMessaging(filter: $filter) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMessagingSubscriptionVariables,
  APITypes.OnUpdateMessagingSubscription
>;
export const onDeleteMessaging = /* GraphQL */ `subscription OnDeleteMessaging($filter: ModelSubscriptionMessagingFilterInput) {
  onDeleteMessaging(filter: $filter) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMessagingSubscriptionVariables,
  APITypes.OnDeleteMessagingSubscription
>;
export const onCreateFeature = /* GraphQL */ `subscription OnCreateFeature($filter: ModelSubscriptionFeatureFilterInput) {
  onCreateFeature(filter: $filter) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFeatureSubscriptionVariables,
  APITypes.OnCreateFeatureSubscription
>;
export const onUpdateFeature = /* GraphQL */ `subscription OnUpdateFeature($filter: ModelSubscriptionFeatureFilterInput) {
  onUpdateFeature(filter: $filter) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFeatureSubscriptionVariables,
  APITypes.OnUpdateFeatureSubscription
>;
export const onDeleteFeature = /* GraphQL */ `subscription OnDeleteFeature($filter: ModelSubscriptionFeatureFilterInput) {
  onDeleteFeature(filter: $filter) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFeatureSubscriptionVariables,
  APITypes.OnDeleteFeatureSubscription
>;
